module.exports = __webpack_public_path__ + "static/media/line-graph-b-LR06.b300a2e7.png";